import RegionalOrganization from './RegionalOrganization';

export default RegionalOrganization;



// WEBPACK FOOTER //
// ./src/components/RegionalOrganization/index.js